import { ComputedExamQuestionItem, ComputedQuestionType } from './types';
import { QuestionTypeEnum } from '~/src/constants/exam/answerFlow';
import { isArray } from 'lodash-es';
import { AnswerModeEnum, ExamModeEnum } from '~/src/constants/exam';

export const getSonTitle = (questionType: number, answerType: number) => {
  let title = '';

  if (
    [
      QuestionTypeEnum.SingleChoice,
      QuestionTypeEnum.GestaltSingleChoice,
      QuestionTypeEnum.MaterialSingleChoice,
    ].includes(questionType)
  ) {
    title = '单选题';
  }

  if (
    [QuestionTypeEnum.MultipleChoice, QuestionTypeEnum.MaterialMultipleChoice].includes(
      questionType
    )
  ) {
    title = '多选题';
  }

  if ([QuestionTypeEnum.Judge, QuestionTypeEnum.MaterialJudge].includes(questionType)) {
    title = '判断题';
  }

  if ([QuestionTypeEnum.Fill].includes(questionType)) {
    title = '填空题';
  }

  if ([QuestionTypeEnum.ShortAnswer, QuestionTypeEnum.MaterialShortAnswer].includes(questionType)) {
    title = '问答题';
  }

  if ([QuestionTypeEnum.Program].includes(questionType)) {
    title = '编程题';
  }

  if ([QuestionTypeEnum.IndefiniteChoice].includes(questionType)) {
    title = '不定项选择题';
  }

  if ([QuestionTypeEnum.GestaltFill].includes(questionType)) {
    title = '完形填空题';
  }

  if ([QuestionTypeEnum.Material].includes(questionType)) {
    if (answerType === 1) {
      title = '单选题';
    }

    if (answerType === 2) {
      title = '多选题';
    }

    if (answerType === 3) {
      title = '判断题';
    }

    if (answerType === 5) {
      title = '问答题';
    }
  }

  return title;
};

export const getQuestionType = (questionType: number, answerType: number): number => {
  // 单选题
  if (questionType === QuestionTypeEnum.SingleChoice) {
    // 普通单选
    return ComputedQuestionType.SingleChoice;
  } else if (questionType === QuestionTypeEnum.GestaltSingleChoice) {
    // 材料单选
    return ComputedQuestionType.MaterialSingleChoice;
  } else if (questionType === QuestionTypeEnum.MaterialSingleChoice) {
    // 材料单选
    return ComputedQuestionType.MaterialSingleChoice;
  }

  // 多选题
  if (questionType === QuestionTypeEnum.MultipleChoice) {
    // 普通多选
    return ComputedQuestionType.MultipleChoice;
  } else if (questionType === QuestionTypeEnum.MaterialMultipleChoice) {
    // 材料多选
    return ComputedQuestionType.MaterialMultipleChoice;
  }

  // 不定向选择题
  if (questionType === QuestionTypeEnum.IndefiniteChoice) {
    if (answerType === 1) {
      // 普通单选
      return ComputedQuestionType.SingleChoice;
    } else if (answerType === 2) {
      // 普通多选
      return ComputedQuestionType.MultipleChoice;
    }
  }

  // 判断题
  if (questionType === QuestionTypeEnum.Judge) {
    // 普通单选
    return ComputedQuestionType.SingleChoice;
  } else if (questionType === QuestionTypeEnum.MaterialJudge) {
    // 材料单选
    return ComputedQuestionType.MaterialSingleChoice;
  }

  // 完形填空题
  if (questionType === QuestionTypeEnum.GestaltFill) {
    // 普通单选
    return ComputedQuestionType.SingleChoice;
  }

  //填空题
  if (questionType === QuestionTypeEnum.Fill) {
    // 普通填空
    return ComputedQuestionType.Fill;
  }

  // 问答题
  if (questionType === QuestionTypeEnum.ShortAnswer) {
    // 普通富文本
    return ComputedQuestionType.RichText;
  } else if (questionType === QuestionTypeEnum.MaterialShortAnswer) {
    // 材料富文本
    return ComputedQuestionType.MaterialRichText;
  }

  // 论文题
  if (questionType === QuestionTypeEnum.Paper) {
    // 普通富文本
    return ComputedQuestionType.RichText;
  }

  // 编程题
  if (questionType === QuestionTypeEnum.Program && answerType === 6) {
    // 普通富文本
    return ComputedQuestionType.RichText;
  }

  // 材料题
  if (questionType === QuestionTypeEnum.Material) {
    if (answerType === 1) {
      // 材料单选
      return ComputedQuestionType.MaterialSingleChoice;
    } else if (answerType === 2) {
      // 材料多选
      return ComputedQuestionType.MaterialMultipleChoice;
    } else if (answerType === 3) {
      // 材料单选
      return ComputedQuestionType.MaterialSingleChoice;
    } else if (answerType === 5) {
      // 材料富文本
      return ComputedQuestionType.MaterialRichText;
    }
  }

  return ComputedQuestionType.UnKnow;
};

export const getQuestionAnswer = (
  answer: string[] | null,
  examMode: ExamModeEnum,
  computedQuestionType: number
): string[] => {
  if (computedQuestionType === ComputedQuestionType.Fill) {
    if (examMode === ExamModeEnum.ChapterPractice) {
      return answer || [];
    } else {
      return answer?.map(i => (i = '')) || [];
    }
  } else {
    if (examMode === ExamModeEnum.ChapterPractice) {
      return answer?.filter(i => i) || [];
    } else {
      return [];
    }
  }
};

export const getOptionValue = (index: number) => {
  const options = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
  ];

  return options[index];
};

export const isDone = (answer: string[]) => {
  return answer && answer.length > 0 && Boolean(answer[0]);
};

export const getChapterPracticeAnswer = (userAnswer: string[], answer: string[]) => {
  if (userAnswer && isArray(userAnswer) && userAnswer.length > 0 && userAnswer.some(i => i)) {
    return userAnswer;
  } else {
    return answer.map(i => (i = ''));
  }
};

export const getFillQuestionIndex = (index: number) => {
  const indexList = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];

  return indexList[index];
};

export const getAnswer = (questionType: ComputedQuestionType, answer: string[]) => {
  if (questionType === ComputedQuestionType.Fill) {
    return answer.every(i => i === '') ? [] : answer;
  } else {
    return answer;
  }
};

export const getAnswerImgs = (questionType: ComputedQuestionType, answer: string[]) => {
  if (
    [ComputedQuestionType.RichText, ComputedQuestionType.MaterialRichText].includes(questionType) &&
    answer[0]
  ) {
    return getRichTextImgList(answer[0]);
  }

  return [];
};

export const getAnswerText = (questionType: ComputedQuestionType, answer: string[]) => {
  if (
    [ComputedQuestionType.RichText, ComputedQuestionType.MaterialRichText].includes(questionType) &&
    answer[0]
  ) {
    return getRichTextInnerText(answer[0]);
  }

  return [];
};

export const getRichTextImgList = (richText: string) => {
  const divEl = document.createElement('div');
  divEl.innerHTML = richText;

  return Array.from(divEl.querySelectorAll('img')).map(i => i.src);
};

export const getRichTextInnerText = (richText: string) => {
  const divEl = document.createElement('div');
  divEl.innerHTML = richText;

  return [divEl.innerText];
};

export const getRichTextAnswer = (
  answer: string[],
  answerImgs: string[] | undefined,
  answerText: string[] | undefined
): string[] => {
  if (!answerText) {
    let imgEl = '';

    if (answerImgs && isArray(answerImgs) && answerImgs.length > 0) {
      answerImgs.forEach(i => {
        imgEl += `<img src="${i}" />`;
      });
    }

    return [`${answer[0]}${imgEl}`];
  } else {
    return answer;
  }
};

// 设置题目禁用
export const setQuestionDisabled = (
  examMode: ExamModeEnum,
  answerMode: AnswerModeEnum,
  isSubjective: boolean,
  answer: string[]
) => {
  if (examMode === ExamModeEnum.ChapterPractice) {
    return !isSubjective && isDone(answer);
  }

  if (answerMode === AnswerModeEnum.PracticeMode) {
    return !isSubjective && isDone(answer);
  }

  return false;
};
